import APIUtils from '@spothero/utils/api';

const AffiliateAPI = {
    /* eslint-disable camelcase */
    get(affiliateCode, subAffiliateCode) {
        const data = {
            affiliate_code: affiliateCode,
            sub_affiliate_code: subAffiliateCode,
        };

        return APIUtils.get(`tune/configurations/`, data);
    },
    /* eslint-enable camelcase */
};

export default AffiliateAPI;
